<template>
	<div class="zhu">
		<!-- 登录弹窗 -->
		<div class="modal-dialog">
			<div class="dialog-header">
				<h3>用户登录</h3>
				<button class="close-btn" @click="handleClose">×</button>
			</div>

			<div class="dialog-body">
				<form class="login-form">
					<!-- 用户名（button→span 清除图标） -->
					<div class="form-item">
						<label class="form-label">用户名</label>
						<div class="form-control">
							<input type="text" v-model="loginForm.username" placeholder="请输入用户名"
								@blur="validateField('username')" class="input-control"
								@focus="clearFieldError('username')"> <!-- 新增：聚焦清除错误提示 -->
							<span class="icon-user"></span>
							<!-- 替换：button改为span，保留v-if和清空逻辑 -->
							<span class="clear-icon" v-if="loginForm.username" @click="loginForm.username = ''">×</span>
						</div>
						<p class="error-message" v-if="errors.username">{{ errors.username }}</p>
					</div>
					<div style="height: 8px;"></div>
					<div class="form-item">
						<label class="form-label">密码</label>
						<div class="form-control">
							<input :type="showPassword ? 'text' : 'password'" v-model="loginForm.password"
								placeholder="请输入密码" @blur="validateField('password')" class="input-control"
								@focus="clearFieldError('password')"> <!-- 新增：聚焦清除错误提示 -->
							<span class="icon-lock"></span>
							<!-- 替换：button改为span，保留v-if和清空逻辑 -->
							<span class="clear-icon" v-if="loginForm.password" @click="loginForm.password = ''">×</span>
						</div>
						<p class="error-message" v-if="errors.password">{{ errors.password }}</p>
					</div>


					<div class="form-item agreement-item">


					</div>
				</form>
			</div>

			<div class="dialog-footer">
				<button class="btn cancel-btn" @click="handleClose">取消</button>
				<button class="btn primary-btn" @click="handleLogin">登录</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		login,
		PROtype
	} from "../../utils/request.js";
	import {
		Setitem
	} from "@/utils/item.js";
	import {
		WSinit,
	} from "@/utils/websocketMessageHandler.js";


	export default {
		name: "LoginDialog",
		data() {
			return {

				showPassword: false,
				rememberMe: false,
				loginForm: {
					username: "",
					password: ""
				},
				errors: {
					username: "",
					password: ""
				}
			};
		},
		methods: {
			// 显示登录框
			show() {
				this.visible = true;
				// 重置表单
				this.$nextTick(() => {
					this.resetForm();
				});
			},

			// 关闭登录框
			handleClose() {
				this.resetForm();
				this.$emit('close');
			},

			// 忘记密码
			handleForgotPassword() {
				this.$toast.info('密码找回功能即将上线');
				// 实际项目中可以跳转到密码找回页面
			},

			// 重置表单
			resetForm() {
				this.loginForm = {
					username: "",
					password: ""
				};
				this.rememberMe = false;
				this.errors = {
					username: "",
					password: ""
				};
				this.showPassword = false;
			},

			// 新增：输入框聚焦时清除对应错误提示（优化体验）
			clearFieldError(field) {
				this.errors[field] = "";
			},

			// 验证单个字段
			validateField(field) {
				switch (field) {
					case 'username':
						this.validateUsername();
						break;
					case 'password':
						this.validatePassword();
						break;
				}
			},

			// 验证所有字段
			validateAll() {
				let isValid = true;
				this.validateUsername();
				this.validatePassword();
				Object.values(this.errors).forEach(error => error && (isValid = false));
				return isValid;
			},

			// 用户名验证
			validateUsername() {
				const value = this.loginForm.username;
				if (!value) this.errors.username = "请输入用户名";
				else if (value.length < 2 || value.length > 20) this.errors.username = "用户名长度必须在2-20个字符之间";
				else this.errors.username = "";
				return !this.errors.username;
			},

			// 密码验证
			validatePassword() {
				const value = this.loginForm.password;
				if (!value) this.errors.password = "请输入密码";
				else if (value.length < 8 || value.length > 20) this.errors.password = "密码长度必须在8-20个字符之间";
				else this.errors.password = "";
				return !this.errors.password;
			},
			async sinitWebSocket(userId, clientId) {

				if (userId) {
					// 清理旧连接（从Vuex获取实例）
					const oldWs = this.$store.state.mews;
					oldWs && await oldWs.close();

					// 初始化新连接
					await WSinit(clientId, userId);

					// 强制更新Vuex状态
					await this.$nextTick();
				} else {
					// console.warn("用户ID不存在，无法初始化WebSocket");
				}
			},
			// 处理登录
			async handleLogin() {
				if (this.validateAll()) {
					// 显示加载状态
					const loading = this.showLoading();
					let data = {
						username: this.loginForm.username,
						password: this.loginForm.password
					};
					let res = await login(data);
					if (res.code === 200) {
						this.$toast.success('登录成功');
						Setitem('name', this.loginForm.username);
						this.$store.commit('setusername', this.loginForm.username);
						let userId = res.userId
						let clientId = "cus"
						Setitem('userid', res.userId)
						await this.sinitWebSocket(userId, clientId)
						await this.Spro()
						this.handleClose();
					} else {
						this.$toast.error(res.message || res.msg || '登录失败，请重试11'); // 兼容msg字段
					}

				} else {
					// 滚动到第一个错误位置
					const firstError = document.querySelector('.error-message:not(:empty)');
					if (firstError) {
						firstError.scrollIntoView({
							behavior: 'smooth',
							block: 'center'
						});
					}
				}
			},
			async Spro() {
				try {
					const res = await PROtype();
					if (res.code === 200) {
						let list = res.list;
						let setkeylist = list.map((res) => res.intent);
						let keylist = [...new Set(setkeylist)];
						let newlist = [];

						keylist.forEach((r) => {
							let s = {
								name: r,
								list: [],
							};
							const filteredList = list.filter((s) => s.intent === r);
							s.list = filteredList;
							newlist.push(s);
						});
						Setitem("setmenu", newlist)
					} else {
						throw new Error("网络错误");
					}
				} catch (error) {
					throw error;
				}
			},

			// 显示加载状态
			showLoading() {
				const loading = document.createElement('div');
				loading.className = 'loading-mask';
				loading.innerHTML = `
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p class="loading-text">登录中...</p>
        </div>
      `;
				document.body.appendChild(loading);
				return {
					close() {
						document.body.removeChild(loading);
					}
				};
			}
		}
	};
</script>

<style lang="less" scoped>
	.zhu {
		position: fixed;
		top: 0;
		left: 0;
		// z-index: 350;
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		background: rgba(0, 0, 0, 0.5);
		/* 新增：弹窗背景遮罩，提升层次 */
	}

	/* 弹窗容器 */
	.modal-dialog {
		position: relative;
		width: 100%;
		max-width: 400px;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}

	/* 弹窗头部 */
	.dialog-header {
		padding: 15px 20px;
		border-bottom: 1px solid #e8e8e8;
		position: relative;

		h3 {
			margin: 0;
			font-size: 16px;
			color: #1f2329;
			font-weight: 500;
		}

		.close-btn {
			position: absolute;
			top: 15px;
			right: 20px;
			background: none;
			border: none;
			font-size: 16px;
			cursor: pointer;
			color: #909399;
			width: 20px;
			height: 20px;
			line-height: 1;
			padding: 0;

			&:hover {
				color: #409eff;
			}
		}
	}

	/* 弹窗主体 */
	.dialog-body {
		margin: 0 auto;
		padding: 20px 30px 20px 10px;
	}

	/* 表单样式 */
	.login-form {
		width: 100%;
	}

	.form-item {
		margin-bottom: 15px;
		position: relative;
		display: flex;
		align-items: center;
		// padding-bottom: 3px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.form-label {
		display: inline-block;
		width: 80px;
		text-align: right;
		margin-right: 10px;
		color: #606266;
		font-size: 14px;
		flex-shrink: 0;
		/* 防止标签被压缩 */
	}

	.form-control {
		flex-grow: 1;
		/* 输入框容器占满剩余空间 */
		position: relative;
		min-width: 0;
		/* 允许容器缩小 */
	}

	.input-control {
		width: 100%;
		height: 36px;
		padding: 0 15 0 5px;
		padding-right: 40px;
		/* 修复：减少右侧内边距，适配span图标 */
		padding-left: 10px;
		/* 新增：给左侧图标预留空间，避免文字重叠 */
		border: 1px solid #dcdfe6;
		/* 默认灰色边框 */
		border-radius: 4px;
		font-size: 14px;
		color: #606266;
		transition: border-color 0.2s;
		box-sizing: border-box;
		background: #fff;
		position: relative;
		z-index: 2;
		/* 高于图标，确保点击不被拦截 */

		&:focus {
			border-color: #409eff;
			/* 聚焦时浅蓝色边框（符合预期） */
			outline: none;
		}
	}

	/* 图标样式（用户/锁） */
	.icon-user,
	.icon-lock {
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
		color: #c0c4cc;
		z-index: 1;
		/* 低于输入框，不拦截点击 */
		pointer-events: none;
		/* 禁止图标响应鼠标事件 */
		width: 16px;
		height: 16px;
	}

	/* 核心：清除图标样式（替换原button） */
	.clear-icon {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
		/* 还原原button交互和样式 */
		width: 20px;
		height: 20px;
		line-height: 1;
		font-size: 14px;
		color: #c0c4cc;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		background: none;
		border: none;
		outline: none;
		z-index: 2;
		/* 与输入框同层，点击正常响应 */

		/* hover效果与原button一致 */
		&:hover {
			color: #606266;
		}
	}

	/* 错误信息 */
	.error-message {
		position: absolute;
		left: 90px;
		top: 100%;
		margin: 5px 0 0 0;
		font-size: 12px;
		color: #f56c6c;
		height: 16px;
		line-height: 16px;
		z-index: 1;
	}

	/* 记住密码与忘记密码区域 */
	.agreement-item {
		margin-top: 10px;
		justify-content: space-between;
		/* 左右布局 */
	}

	.checkbox-label {
		display: flex;
		align-items: center;
		margin-left: 90px;
		cursor: pointer;
	}

	.forgot-password {
		color: #409eff;
		cursor: pointer;
		text-decoration: none;
		font-size: 12px;
		margin-right: 0;

		&:hover {
			text-decoration: underline;
		}
	}

	.custom-checkbox {
		position: absolute;
		width: 0;
		height: 0;
		opacity: 0;

		&:checked+.checkbox-icon {
			background-color: #409eff;
			border-color: #409eff;

			&::after {
				display: block;
			}
		}
	}

	.checkbox-icon {
		display: inline-block;
		width: 14px;
		height: 14px;
		border: 1px solid #dcdfe6;
		border-radius: 2px;
		position: relative;
		margin-right: 5px;

		&::after {
			content: "";
			position: absolute;
			width: 4px;
			height: 8px;
			top: 1px;
			left: 4px;
			border: 2px solid #fff;
			border-top: none;
			border-left: none;
			transform: rotate(45deg);
			display: none;
		}
	}

	.checkbox-text {
		font-size: 12px;
		color: #606266;
	}

	/* 弹窗底部 */
	.dialog-footer {
		padding: 10px 20px 20px;
		text-align: center;
		border-top: 1px solid #e8e8e8;
	}

	.btn {
		padding: 8px 16px;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
		transition: all 0.2s;
		border: 1px solid transparent;
		margin: 0 5px;
	}

	.cancel-btn {
		background-color: #fff;
		border-color: #dcdfe6;
		color: #606266;

		&:hover {
			background-color: #f5f7fa;
			border-color: #c0c4cc;
		}
	}

	.primary-btn {
		background-color: #409eff;
		border-color: #409eff;
		color: #fff;

		&:hover {
			background-color: #66b1ff;
			border-color: #66b1ff;
		}
	}

	/* 加载状态样式 */
	.loading-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 9999;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.loading-spinner {
		text-align: center;
	}

	.spinner {
		width: 40px;
		height: 40px;
		margin: 0 auto;
		border: 4px solid rgba(255, 255, 255, 0.2);
		border-radius: 50%;
		border-top-color: #fff;
		animation: spin 1s ease-in-out infinite;
	}

	.loading-text {
		color: #fff;
		margin-top: 10px;
		font-size: 14px;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>